import {FC} from "react";

interface IntroProps {
    children: string;
}

export function Intro({children}: IntroProps) {
    return <h2 className='intro-text'>{children}</h2>;
}
